import { getOptionValue, fieldToOptionDeleted } from 'services/helpers';

import {
  setDelayAmount,
  checkDeleted,
  displayNameDescriptor,
  isBeforeAfter,
  isDateAndTime,
} from 'pages/AutomationEngine/helpers';

import { PastDateActionOptions } from './types';

import { AUTOMATION_STEPS } from 'pages/AutomationEngine/steps';

const forApi = (orgDetails) => {
  const { fieldId, period, delayAmount, time, dateOffsetDays, ...other } =
    orgDetails;

  return {
    stepGoal: {
      ...orgDetails,
      delayAmount: setDelayAmount(delayAmount),
      triggers: [
        {
          type: AUTOMATION_STEPS.on_or_around_date.type,
          triggerOnOrAroundDate: {
            ...other,
            fieldId: getOptionValue(fieldId),
            ...(!isDateAndTime(other.dateOffset)
              ? { time, period: period ? period.toLowerCase() : null }
              : null),
            ...(isBeforeAfter(other.dateOffset) ? { dateOffsetDays } : null),
          },
        },
      ],
    },
  };
};

const forFlow = (firstTrigger, addErrorMessage, messageDictionary) => {
  const {
    field,
    period,
    dateOffsetDays,
    dateOffset,
    time,
    everyYear,
    pastDateAction,
  } = firstTrigger.triggerOnOrAroundDate;
  checkDeleted(
    messageDictionary,
    addErrorMessage,
    field,
    displayNameDescriptor
  );
  return {
    fieldId: fieldToOptionDeleted(field),
    everyYear,
    period: period ? period.toUpperCase() : null,
    dateOffsetDays: dateOffsetDays || null,
    dateOffset,
    time,
    type: AUTOMATION_STEPS.on_or_around_date_goal.type,
    pastDateAction:
      pastDateAction || PastDateActionOptions.PROCEED_DOWN_MET_PATH,
  };
};

export const onOrAroundDateDTO = {
  forApi,
  forFlow,
};
